export default "__VITE_ASSET__JZUyJXy7__"